import tseInstance from '../instance'

const updateTseNotification = (data) => {
	return tseInstance.put('/company/tse/notification', data)
}

export default updateTseNotification
